import { render, staticRenderFns } from "./PwaPromptSafari.vue?vue&type=template&id=3a63a61e&scoped=true&"
import script from "./PwaPromptSafari.vue?vue&type=script&lang=js&"
export * from "./PwaPromptSafari.vue?vue&type=script&lang=js&"
import style0 from "./PwaPromptSafari.vue?vue&type=style&index=0&id=3a63a61e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63a61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a63a61e')) {
      api.createRecord('3a63a61e', component.options)
    } else {
      api.reload('3a63a61e', component.options)
    }
    module.hot.accept("./PwaPromptSafari.vue?vue&type=template&id=3a63a61e&scoped=true&", function () {
      api.rerender('3a63a61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/PwaPromptSafari.vue"
export default component.exports